import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getGroupByIdSagaAction, getGroupsSagaAction, removeGroupSagaAction } from "../../redux/sagaActions";

const GroupsList = () => {
    const dispatch = useDispatch();

    const groups = useSelector(state => state.groups);
    const currentEstablishment = useSelector(state => state.currentEstablishment);

    // Получение списка товаров
    useEffect(() => {
        if (!currentEstablishment) return;

        dispatch(getGroupsSagaAction());
    }, [currentEstablishment]);

    return (
        <div className="settings">
            {
                groups.map(elem => {
                    return (
                        <div className="setting" key={ elem.id }>
                            <div className="controls">
                                <i
                                    className="control control--edit"
                                    onClick={ () => dispatch(getGroupByIdSagaAction({ id: elem.id })) }
                                />
                                {/*<i className="control control--move" />*/}
                                <i className="control control--remove" onClick={ () => {
                                    if (window.confirm('Вы действительно хотите удалить эту группу?')) {
                                        dispatch(removeGroupSagaAction({ id: elem.id }));
                                    }
                                } }/>
                            </div>
                            <div className="setting__caption">{ elem.name }</div>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default GroupsList;